import { Inject, Injectable } from '@angular/core';
import {Subject} from 'rxjs';
import {ToothUiManagerModel} from './tooth-ui-manager.model';

@Injectable()

export class ToothUiManagerService {
  public selectionSubject: Subject<ToothUiManagerModel>;
  public modelLoadedSubject: Subject<ToothUiManagerModel[]>;
  public childViewLoadedSubject: Subject<any>;

  constructor() {
    this.selectionSubject = new Subject<ToothUiManagerModel>();
    this.modelLoadedSubject = new Subject<ToothUiManagerModel[]>();
    this.childViewLoadedSubject = new Subject<any>();
  }

  public notifyChildrenOfGroupSelection(models: ToothUiManagerModel[]) {
    for (const model of models) {
      this.selectionSubject.next(model);
    }
  }

  public notifyChildrenOfModelLoaded(models: ToothUiManagerModel[]) {
    this.modelLoadedSubject.next(models);
  }
}
